import { Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { downloadBlobFile, toBase64 } from '../helpers/file-utils';

/**
 * Service to provide file utility functions with dependency injection support.
 * This allows for easier testing by enabling spying on file-related functions.
 */
@Injectable({
  providedIn: 'root',
})
export class FileUtilsService {
  /**
   * Downloads a blob file with the specified name
   */
  downloadBlobFile = (
    response: HttpResponse<Blob>,
    fileName: string,
    extension?: string
  ) => {
    downloadBlobFile(response, fileName, extension);
  };

  /**
   * Converts a file to base64 string
   */
  toBase64 = toBase64;
}
